var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#535C69",
    d: "M907.061669,258 L908.990291,259.928622 L902.07275,266.844782 L900.144127,264.91616 L907.061669,258 Z M899.007124,267.723439 C898.987783,267.79666 899.008506,267.874026 899.061004,267.927906 C899.114884,267.981786 899.19225,268.002509 899.265471,267.981786 L901.551911,267.365621 L899.623289,265.436999 L899.007124,267.723439 Z",
    transform: "translate(-899 -258)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.ddc4c1adfb60892dc11f953eca552fe1.svg";
export { ForwardRef as ReactComponent };